module.exports = __webpack_public_path__ + "img/vertical.cdf802c0.svg";